import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AuthCardProps } from "@/types";
import surfSnapLogo from "/lovable-uploads/3226e037-e0cd-45f1-af09-d459aac7c831-removebg-cut.png";

export const AuthCard = ({ title, children }: AuthCardProps) => {
  return (
    <Card className="w-full max-w-md mx-auto mt-3">
      <CardHeader className="space-y-1 flex flex-col items-center">
        <div className="w-40 h-36 mb-4">
          <img
            src={surfSnapLogo}
            alt="SurfSnap Logo"
            className="w-full h-full object-contain"
          />
        </div>
        <CardTitle className="text-2xl text-center">{title}</CardTitle>
        {/* <CardDescription className="text-center">
          Where Surfing Meets Photography
        </CardDescription> */}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
};
